module.exports = __webpack_public_path__ + "img/second-section-2.59a25b95.jpg";